module.exports = __webpack_public_path__ + "static/media/Logo_circle.04b35f5b.png";